// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3unuj","row":"Node_row__3Kk_1","label":"Node_label__1SP9n","footer":"Node_footer__1ho4R"};